class AccountController {
  constructor () {
    const vm = this;
    vm.name = 'account';
  }
}

export default AccountController;
